import { SearchCriteria } from './search-criteria';
import { RequestPermissionNotificationType } from '../enums/request-permission-notification-type';
import { RequestPermissionNotificationItem } from '../classes/notification/request-permission-notification-item';
import { RequestPermissionNotificationPayment } from '../classes/notification/request-permission-notification-payment';
import { BookingStatus } from '../enums/booking-status';
import { PaidStatus } from '../enums/paid-status';
import { EditedTransaction } from '../classes/notification/edited-transaction';

export class MakeRequestPermissionCriteria extends SearchCriteria {
  public BranchId: number;
  public ClientId: number;
  public BookingId?: number;

  public TotalAmountBeforeDiscount: number;
  public TotalDiscountAmount: number;
  public TotalAmountAfterDiscount: number;

  public TotalAmount: number;
  public RefundedItemsCount: number;
  public RequestPermissionNotificationType: RequestPermissionNotificationType;

  public RefundReasonId: number;
  public Notes: string;

  public EditedTransaction: EditedTransaction;

  public RequestPermissionNotificationItems: RequestPermissionNotificationItem[];
  public RequestPermissionNotificationPayments: RequestPermissionNotificationPayment[];

  public BookingDateTime: Date;
  public BookingStatus: BookingStatus;
  public BookingPaidStatus: PaidStatus;
}
